import type { AjudaDaPagina, ChaveDePagina } from "./tipos";

export const AJUDA_DAS_CONFIGURACOES = {
  configuracoes: {
    titulo: "Configurações",
    resumo: "As configurações da organização ativa, divididas em seções. Só para quem administra a organização.",
    passos: [
      "Para abrir uma seção: escolha na lista ao lado (no celular, toque na seção).",
      "Organização: Dados, Expediente, Área de atuação e, conforme o tipo, Especialidades, Laboratório ou Radiologia.",
      "Funcionamento: Agenda e Pacientes na clínica; Etiquetas no laboratório.",
      "Equipe e acesso: Permissões, Registro de exportações (proprietário e sócios) e, para o proprietário, Propriedade e Excluir organização. Dados: Importar e Integrações.",
    ],
    dicas: [
      "Entram aqui o dono, os sócios e quem tem a permissão de configurar a organização.",
      "Suas preferências pessoais ficam em Minha conta.",
    ],
  },
  "configuracoes:dados": {
    titulo: "Configurações · Dados",
    resumo: "Nome, CNPJ, telefone e endereço da organização; no laboratório, também o prazo de produção.",
    passos: [
      "Para renomear: altere o Nome da organização e clique em Salvar.",
      "Para os dados cadastrais: preencha CNPJ e telefone e clique em Salvar.",
      "Para o endereço: digite o CEP e clique em Buscar para preencher o resto, complete o número e salve.",
      "No laboratório, para o prazo de produção: defina os dias (úteis ou corridos), se trabalha aos sábados e quantos dias antes avisar a produção, e clique em Salvar prazo.",
      "No laboratório, para a taxa de urgência: escolha Valor fixo ou Porcentagem (dos serviços), informe o valor e clique em Salvar taxa. Ela vem marcada ao aceitar um pedido urgente e entra como acréscimo.",
    ],
    dicas: [
      "Trabalho sem prazo combinado com a clínica que passa do prazo de produção entra em Atrasados.",
      "Na organização pessoal o nome é o seu, e muda em Minha conta › Perfil.",
    ],
  },
  "configuracoes:expediente": {
    titulo: "Configurações · Expediente",
    resumo: "Os dias e horários em que a organização funciona.",
    passos: [
      "Para definir: marque os Dias de funcionamento e os horários em Abre às e Fecha às.",
      "Para o almoço: clique em Adicionar intervalo de almoço.",
      "Para gravar: clique em Salvar expediente.",
    ],
    dicas: [
      "O intervalo de almoço aparece bloqueado na grade da Agenda.",
      "Sem expediente, a Equipe não consegue dizer quem está fora do horário, e a Agenda usa um intervalo padrão.",
    ],
  },
  "configuracoes:atuacao": {
    titulo: "Configurações · Área de atuação",
    resumo: "Os perfis da organização (clínica, laboratório, radiologia), que definem quais áreas aparecem no menu.",
    passos: [
      "Para mudar: marque os perfis da organização e clique em Salvar.",
      "Para combinar áreas: uma organização pode ter mais de um perfil; o menu e as seções de Configurações se ajustam.",
      "Para conferir o efeito: depois de salvar, veja os itens novos no menu lateral.",
    ],
  },
  "configuracoes:especialidades": {
    titulo: "Configurações · Especialidades",
    resumo: "As especialidades da clínica. Cada uma traz os procedimentos dela para a agenda.",
    passos: [
      "Para adicionar: clique em Adicionar especialidade e, em seguida, marque os procedimentos dela que a clínica faz.",
      "Para ajustar os procedimentos de uma especialidade: abra o cartão dela e clique em Editar. Desmarcar desativa o procedimento sem apagar o histórico.",
      "Para remover: use Remover no cartão. Os procedimentos dela continuam na clínica.",
    ],
    dicas: [
      "Preço, duração e cor de cada procedimento ficam na página Procedimentos.",
      "Só aparece em clínica. Na organização pessoal, as especialidades ficam em Minha conta › Profissional.",
    ],
  },
  "configuracoes:perfil-publico": {
    titulo: "Configurações · Perfil público",
    resumo: "Como as clínicas veem o laboratório: nome, logo, serviços, endereço, visibilidade na busca e o link público do catálogo.",
    passos: [
      "Para editar o perfil: altere nome, logo e serviços e salve.",
      "Para ser encontrado: escolha Público (qualquer clínica acha pelo nome) ou Só por convite (conecta só quem recebe seu link).",
      "Para divulgar o catálogo: ligue o link público. O link e o QR levam ao catálogo, de onde o dentista pede conexão ou faz um pedido.",
    ],
    dicas: [
      "O prazo de produção fica em Configurações › Dados.",
      "Só aparece em organização com o perfil Laboratório.",
    ],
  },
  "configuracoes:radiologia": {
    titulo: "Configurações · Radiologia",
    resumo: "O perfil do centro de radiologia: serviços oferecidos, logo e endereço de atendimento.",
    passos: [
      "Para editar: marque os serviços, envie a logo e salve.",
      "Para o endereço de atendimento: use o mesmo da organização ou informe outro.",
      "Para conferir: os dados salvos valem para o perfil de radiologia da organização.",
    ],
    dicas: ["Só aparece em organização com o perfil Radiologia."],
  },
  "configuracoes:agenda": {
    titulo: "Configurações · Agenda",
    resumo: "Como a agenda da clínica funciona e aparece: horários, visual, lembretes e regras.",
    passos: [
      "Em Horários: escolha o slot da grade, a duração padrão de nova consulta e se mostra os fins de semana.",
      "Em Visual: escolha o estilo do card, o que aparece nele e a linha do horário atual.",
      "Em Lembretes: deixe pronto o lembrete por WhatsApp — quando enviar e o texto da mensagem. O envio automático começa quando a integração com o WhatsApp for ativada.",
      "Em Comportamento: decida o que acontece ao agendar em horário ocupado e se pede confirmação ao arrastar uma consulta.",
      "Para gravar: clique em Salvar alterações (ou em Restaurar padrões para voltar ao original).",
    ],
    dicas: ["Só aparece em clínica."],
  },
  "configuracoes:pacientes": {
    titulo: "Configurações · Pacientes",
    resumo: "Como a clínica quer o cadastro, a anamnese e a ficha do paciente. Sem mudar nada, tudo funciona como sempre funcionou.",
    passos: [
      "Cadastro: para cada campo, escolha Opcional, Obrigatório ou Oculto. Vale para o Novo paciente, a aba Dados e o link de autocadastro.",
      "Anamnese: escolha por quantos dias o link vale, o texto da mensagem, de quanto em quanto tempo pedir renovação e se a agenda lembra de enviar.",
      "Visualização da ficha: desligue as abas que a clínica não usa. Início e Dados aparecem sempre.",
      "Para voltar ao padrão: clique em Restaurar padrão e depois em Salvar alterações.",
    ],
    dicas: [
      "As perguntas da anamnese não mudam: são as mesmas para todas as clínicas, preparadas para validação clínica.",
      "Paciente criado pelo encaixe da agenda ou pela importação não é barrado: aparece com o selo Cadastro incompleto até alguém completar.",
      "Quem pode mudar estas configurações: Proprietário, sócios e quem tiver a permissão Personalizar cadastro, anamnese e ficha (por padrão, o Administrador).",
    ],
  },
  "configuracoes:etiquetas": {
    titulo: "Configurações · Etiquetas",
    resumo: "Como saem as etiquetas do laboratório: campos, ordem, tamanho e impressão.",
    passos: [
      "Para escolher a etiqueta: use Produção (uma por serviço), Entrega (uma por pedido) ou Única (produção + expedição).",
      "Para montar: marque os campos que aparecem e arraste para mudar a ordem; ajuste o tamanho e a letra.",
      "Para conferir: veja a Prévia e use Imprimir teste.",
      "Para gravar: clique em Salvar (Restaurar padrão volta ao original).",
    ],
    dicas: [
      "Com Imprimir ao aceitar o pedido ligado, aceitar um pedido já abre a impressão das etiquetas.",
      "Para imprimir sem a janela de impressão, siga o passo a passo de Imprimir direto, sem perguntar.",
    ],
  },
  "configuracoes:permissoes": {
    titulo: "Configurações · Permissões",
    resumo: "O que cada papel pode acessar na organização.",
    passos: [
      "Para liberar ou tirar um acesso: marque ou desmarque a caixa na linha do recurso e na coluna do papel. A mudança vale na hora.",
      "Para saber quem é afetado: os papéis configuráveis são Visualizador, Recepção, Assistente, Dentista e Administrador.",
      "Para ajustar o acesso de uma pessoa só: use Alterar acesso no membro, na página Equipe.",
    ],
    dicas: [
      "Proprietário e sócios sempre têm acesso completo e por isso não aparecem na tabela.",
      "Só o proprietário e os sócios editam as permissões.",
      "Exportar a lista de pacientes e as planilhas de pedidos e produção são permissões à parte: ver a lista não basta para levá-la para fora. Por padrão, só o Administrador tem.",
    ],
  },
  "configuracoes:exportacoes": {
    titulo: "Configurações · Registro de exportações",
    resumo: "Quem levou dados para fora da organização nos últimos 90 dias.",
    passos: [
      "Para conferir: cada linha mostra quando, quem, o que foi exportado e, nas planilhas, quantas linhas e quais colunas.",
      "Para mudar quem pode exportar: use Permissões (Exportar a lista de pacientes; Exportar planilhas de pedidos e produção).",
    ],
    dicas: [
      "Entram as planilhas, a exportação completa da organização e as impressões de anamnese e de orçamento.",
      "Só o proprietário e os sócios veem este registro.",
    ],
  },
  "configuracoes:propriedade": {
    titulo: "Configurações · Propriedade",
    resumo: "Transferir a propriedade da organização para outro membro da equipe.",
    passos: [
      "Para transferir: escolha um membro ativo da equipe e clique em Transferir propriedade.",
      "Para confirmar: digite o código de 6 dígitos enviado ao seu e-mail (vale por 10 minutos).",
      "Depois da transferência, você passa a ser Administrador.",
    ],
    dicas: ["Só o proprietário vê esta seção, e a transferência também pede o PIN de segurança."],
  },
  "configuracoes:exclusao": {
    titulo: "Configurações · Excluir organização",
    resumo: "Apagar a organização e os dados dela. Só o proprietário faz.",
    passos: [
      "Antes de excluir: use Gerar exportação para baixar um .zip com planilhas, fichas, arquivos e notas fiscais.",
      "Para excluir: clique em Excluir organização, digite o nome da organização e a sua senha e confirme.",
      "Para voltar atrás: durante 7 dias a organização fica só leitura e você pode clicar em Desfazer exclusão.",
    ],
    dicas: [
      "Depois dos 7 dias os dados são apagados e os membros saem. Isso não tem volta.",
      "A seção mostra quantos pacientes, consultas, arquivos e pedidos serão apagados.",
    ],
  },
  "configuracoes:importar": {
    titulo: "Configurações · Importar",
    resumo: "Trazer pacientes e consultas de outra plataforma a partir de planilhas.",
    passos: [
      "Para importar: escolha Pacientes ou Agenda e arraste o arquivo CSV ou Excel (até 50 MB).",
      "Para conferir antes: relacione cada coluna do arquivo a um campo do sistema e escolha o que fazer com duplicatas (Pular duplicatas, Atualizar existentes ou Criar sempre).",
      "Para concluir: clique em Importar agora e confira o resultado.",
      "Para desfazer uma importação: no histórico de importações, use Apagar para remover os registros criados.",
      "Para testar com dados fictícios: em Dados de exemplo, use Carregar (e Remover quando quiser).",
    ],
    dicas: [
      "Fichas clínicas ainda está em breve.",
      "A planilha exportada na página Pacientes serve de modelo.",
    ],
  },
  "configuracoes:integracoes": {
    titulo: "Configurações · Integrações",
    resumo: "Conectar WhatsApp, Google Agenda e meios de pagamento à organização. Ainda não disponível.",
    passos: [
      "Por enquanto não há o que configurar aqui: as integrações estão marcadas como Em breve.",
      "Para os lembretes da agenda: as preferências de WhatsApp ficam em Configurações › Agenda › Lembretes.",
      "Para os avisos de cada pessoa por e-mail e WhatsApp: cada um escolhe em Minha conta › Notificações.",
    ],
  },
} satisfies Partial<Record<ChaveDePagina, AjudaDaPagina>>;
